import React, { lazy } from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import ModalWrapper from './component/Modal/ModalWrapper';
import NavWrapper from './component/Modal/NavWrapper';
import MaterialWrapper from './component/Modal/MaterialWrapper';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Home = lazy(() => import("./views/home/Home2"))
const Login = lazy(() => import("./views/login/LoginPage"))
const RegisterPlatform = lazy(() => import("./views/register/RegisterPlatform"))
const RegisterPage = lazy(() => import("./views/register/RegisterPage"))
const Course = lazy(() => import("./views/myCourseList/myCourseList"))
const CourseList = lazy(() => import("./views/home/Home"))
const MyProfile = lazy(() => import("./views/userSetting/myProfile"))
const UserSetting = lazy(() => import("./views/userSetting/userSetting"))
const Stepper = lazy(() => import("./component/Stepper/CourseStepper"))
// const NotFound = lazy(() => import("./views/notFound/notFound"))
const Faq = lazy(() => import("./views/faq/Faq"))
const ResetPassword = lazy(() => import("./views/resetPassword/ResetPasswordForm"))
const FlowBukalapak = lazy(() => import("./views/platformGuide/CourseBukalapak"))
const FlowTokopedia = lazy(() => import("./views/platformGuide/CourseTokopedia"))
const FlowKemnaker = lazy(() => import("./views/platformGuide/CourseKemnaker"))
const LastFlowBukalapak = lazy(() => import("./views/platformGuide/LastCourseBukalapak"))
const LastFlowTokopedia = lazy(() => import("./views/platformGuide/LastCourseTokopedia"))
const LastFlowKemnaker = lazy(() => import("./views/platformGuide/LastCourseKemnaker"))
const CustomerService = lazy(() => import("./component/CustomerService/CustomerService"))
const FlowPlatform = lazy(() => import("./views/platformGuide/FlowPlatform"));
const LastFlowPlatform = lazy(() => import("./views/platformGuide/LastCoursePlatform"));
const Webinar = lazy(() => import("./views/webinar/Webinar"));
const InfoPrakerja = lazy(() => import("./views/infoPrakerja/InfoPrakerja"));
const VerifCertificate = lazy(() => import("./component/Materi Sertifikat/VerifCertificate"));
const Redirect = lazy(() => import("./views/redirect/Redirect"));
const PrivacyPolicy = lazy(() => import("./views/privacy"));
const UploadVermuk = lazy(() => import("./views/upload-vermuk/UploadVermuk"));
const TabunganPenunjangKarir = lazy(() => import("./views/tabungan-karir"));
const TukarPoin = lazy(() => import("./component/TukarPoin"))
const CourseTPK = lazy(() => import("./views/myCourseList/myCourseListTPK"))

const loggedInUserBabaPrakerja = JSON.parse(localStorage.getItem('loggedInUserBabaPrakerja'))

const AppRouter = ({backdrop}) => {
  const classes = useStyles()
  return (
    <Router>
      <Routes>
        <Route path="/" element={loggedInUserBabaPrakerja === null ? <Home /> : <Course />} />
        <Route path="login" element={<Login/>} />
        <Route path="platform" element={<RegisterPlatform />} />
        <Route path="register" element={<RegisterPage/>} />
        <Route path="register-account" element={<RegisterPage />} />
        <Route path="panduan-platform" element={<FlowPlatform/>} />
        <Route path="faq" element={<Faq />}/>
        <Route path="*" element={<Home />}/>
        <Route path="reset-password/:id" element={<ResetPassword />} />
        <Route path="panduan-bukalapak" element={<FlowBukalapak/>} />
        <Route path="panduan-tokopedia" element={<FlowTokopedia/>} />
        <Route path="panduan-kemnaker" element={<FlowKemnaker/>} />
        <Route path="panduan-akhir-bukalapak" element={<LastFlowBukalapak/>} />
        <Route path="panduan-akhir-tokopedia" element={<LastFlowTokopedia/>} />
        <Route path="panduan-akhir-kemnaker" element={<LastFlowKemnaker/>} />
        <Route path="tanya-cs" element={<CustomerService/>} />
        <Route path="info-prakerja" element={<InfoPrakerja />} />
        <Route path="course" element={<CourseList />} />
        <Route path="certificate" element={<VerifCertificate />} />
        <Route path="pmo/redirect" element={<Redirect />} />
        <Route path="syarat-dan-ketentuan" element={<PrivacyPolicy />} />
        {loggedInUserBabaPrakerja !== null &&
        <React.Fragment>
        <Route path="my-course">
          <Route path="/" element={<Course />} />
          <Route path="search_param=:param" element={<Course />} />
          <Route path="course_id=:id&material_id=:material_id" element={<Stepper />} />
          <Route path="panduan-bukalapak" element={<FlowBukalapak/>} />
          <Route path="panduan-tokopedia" element={<FlowTokopedia/>} />
          <Route path="panduan-kemnaker" element={<FlowKemnaker/>} />
          <Route path="panduan-akhir-platform" element={<LastFlowPlatform/>} />
          <Route path="panduan-akhir-bukalapak" element={<LastFlowBukalapak/>} />
          <Route path="panduan-akhir-tokopedia" element={<LastFlowTokopedia/>} />
          <Route path="panduan-akhir-kemnaker" element={<LastFlowKemnaker/>} />
        </Route>
        <Route path="live-session_id=:id" element={<Webinar />} />
        <Route path="my-profile" element={<MyProfile />} />
        <Route path="user-edit" element={<UserSetting />} />
        <Route path="upload-vermuk" element={<UploadVermuk />} />
        {/* <Route path="tabungan-penunjang-karir">
          <Route path="/" element={<TabunganPenunjangKarir />} />
          <Route path="tukar-poin" element={<TukarPoin/>} />
          <Route path="course" element={<CourseTPK />} />
        </Route> */}
        </React.Fragment>
        }
      </Routes>
      <NavWrapper />
      <ModalWrapper />
      <MaterialWrapper />
      <Backdrop className={classes.backdrop} open={backdrop}>
        <CircularProgress color="inherit" />
    </Backdrop>
    </Router>
  )
}


const mapStateToProps = (state) => {
  return {
      backdrop: state.backdropReducer.show,
  }
}

export default connect(mapStateToProps, null)(AppRouter);
